import httpService from "..";

const smsQueueUrl = () =>
  `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/sms-queue`;

export type SmsQueueStatus =
  | "QUEUED"
  | "SENT"
  | "FAILED"
  | "CANCELLED";

export type SmsQueueType = "NEW_POLICY" | "APPLICATION";

export interface SmsQueueItem {
  id: number;
  createdAt: string;
  updatedAt: string;
  status: SmsQueueStatus;
  smsType: SmsQueueType | string;
  toCellphone: string;
  groupId: number | null;
  memberId: number | null;
  lapseRunId: number | null;
  meta: string | null;
  sentAt: string | null;
  errorMessage: string | null;
  flushedBy: string | null;
  messageBody: string | null;
  toName?: string | null;
}

export interface GetSmsQueueParams {
  status?: SmsQueueStatus;
  smsType?: SmsQueueType | string;
  lapseRunId?: number | null;
  memberId?: number | null;
}

export interface GetSmsQueueData {
  smsSendEnabled: boolean;
  lapseSmsSendEnabled: boolean;
  items: SmsQueueItem[];
}

export interface CancelSmsQueuePayload {
  ids: number[];
}

export interface FlushSmsQueuePayload {
  ids?: number[];
  lapseRunId?: number | null;
}

const firstNonEmpty = (...values: unknown[]): string => {
  for (const value of values) {
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return "";
};

/** Normalize list/detail payloads — field names can differ across endpoints. */
export const normalizeSmsQueueItem = (raw: any): SmsQueueItem => {
  const toCellphone = firstNonEmpty(
    raw?.toCellphone,
    raw?.ToCellphone,
    raw?.toPhone,
    raw?.ToPhone,
    raw?.cellphone,
    raw?.Cellphone
  );

  const messageBody = firstNonEmpty(
    raw?.messageBody,
    raw?.MessageBody,
    raw?.message,
    raw?.Message,
    raw?.body
  );

  return {
    id: Number(raw?.id),
    createdAt: raw?.createdAt ?? raw?.CreatedAt ?? "",
    updatedAt: raw?.updatedAt ?? raw?.UpdatedAt ?? "",
    status: raw?.status ?? raw?.Status,
    smsType: raw?.smsType ?? raw?.SmsType ?? "",
    toCellphone,
    groupId: raw?.groupId ?? raw?.GroupId ?? null,
    memberId: raw?.memberId ?? raw?.MemberId ?? null,
    lapseRunId: raw?.lapseRunId ?? raw?.LapseRunId ?? null,
    meta: raw?.meta ?? raw?.Meta ?? null,
    sentAt: raw?.sentAt ?? raw?.SentAt ?? null,
    errorMessage: raw?.errorMessage ?? raw?.ErrorMessage ?? null,
    flushedBy: raw?.flushedBy ?? raw?.FlushedBy ?? null,
    messageBody: messageBody || null,
    toName: raw?.toName ?? raw?.ToName ?? null,
  };
};

export const getSmsQueueApi = async (params: GetSmsQueueParams = {}) => {
  return await httpService(smsQueueUrl(), "get", undefined, {
    status: params.status ?? "",
    smsType: params.smsType ?? "",
    lapseRunId: params.lapseRunId != null ? params.lapseRunId : "",
    memberId: params.memberId != null ? params.memberId : "",
  });
};

export const getSmsQueueByIdApi = async (id: number | string) => {
  return await httpService(`${smsQueueUrl()}/${id}`, "get");
};

export const cancelSmsQueueApi = async (data: CancelSmsQueuePayload) => {
  return await httpService(`${smsQueueUrl()}/cancel`, "post", data);
};

export const flushSmsQueueApi = async (data: FlushSmsQueuePayload = {}) => {
  return await httpService(`${smsQueueUrl()}/flush`, "post", data);
};
